import React, { Component } from 'react';
import EntityAutocomplete from '../../components/common/EntityAutocomplete';
import ReactTable from "react-table";
import { heartbeatsConstants } from '../../data/constants/heartbeats';

import cellHeaderHOC from '../../components/common/Datagrid/CellHeaderHOC';

const CellHeaderTable = cellHeaderHOC(ReactTable);

export default class NotificationReport extends React.Component {
  state = {
    showInfoIcon: false,
    percentChangeOptions: [10, 20, 40, 60, 80, 100, 200, 300],
    minimumStreamsOptions: [500, 1000, 5000, 10000, 50000, 100000],
    displayTooltip: false
  }
  
  allowedFrequencies = {
      "threshold": [1],
      "minimum_streams": [1]
  }

  handleMouseEnter = () => {
    this.setState({
      showInfoIcon: false
    })
  }
  handleMouseLeave = () => {
    this.setState({
      showInfoIcon: false
    })
  }

  capitalize = s => {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  hideTooltip = () => {
    this.setState({displayTooltip: false})
  }

  showTooltip = () => {
    this.setState({displayTooltip: true})
  }

  render(){
    const { onChangeSetting, onChangeEntity, onClickItem, onRemoveItem, inputValue, showDropdown, products, title, description, setting, frequencies, reportID} = this.props;
    const { showInfoIcon } = this.state;
    const value = setting && Object.keys(setting.settings).reverse()[0];
    const productsColumns = [
      {
        id: 'artist',
        Header: 'Artist',
        accessor: 'artist',
        Cell: props => {
          return <div className="overflow-text">{props.original.artists[0].artist.name}</div>
        }
      },
      {
        id: 'product',
        Header: 'Product',
        Cell: props => {
          return <div className="overflow-text">{props.original.product.title}</div>
        }
      },
      {
        id: 'barcode',
        Header: 'Barcode',
        accessor: 'barcode',
        Cell: props => {
          return <div>{props.original.product.barcode}</div>
        }
      },
      {
        id: 'actions',
        accessor: 'id',
        className: 'remove-cell-btn',
        // width: 40,
        Cell: props => {
          return <a style={{color: '#ff1500'}} onClick={(e) => onRemoveItem(e, props.original, 'products', setting, value)} >X</a>
        }
      }
    ];

    const tooltipSetting = {
      release_weeks: { text: 'Release weeks to include in the report', placement: 'right'},
      threshold: { text: 'Percentage change in streams', placement: 'right'},
      minimum_streams: { text: 'Minimum number of streams', placement: 'right'},
      avg_streams: { text: 'Average daily streams(per track)', placement: 'right'}
    };

    let filteredFrequencies = {};
    for(let frequencyCode in frequencies){
        const frequencyID = frequencies[frequencyCode];
        if(this.allowedFrequencies[value]!==undefined) {
            if(!this.allowedFrequencies[value].includes(frequencyID)) {
                continue;
            }
        }
        filteredFrequencies[frequencyCode] = frequencyID;
    }
    
    const frequencyValues = Object.values(filteredFrequencies);

    return(
      <div className="notificationReportRoot">
        <div className="notificationReportInfo">
          <h2>{title}</h2>
          <h4>{description}</h4>
          
        </div>
        <div className="notification-report-count">
          {
            ( reportID == 2)
            ?
            <div >
                <select
                  className="percentSelect"
                  value={setting ? setting.settings.threshold : null}
                  onChange={(e) => onChangeSetting(e, setting, "threshold", "settings")}
                >
                {this.state.percentChangeOptions.map(option => {
                  return (
                    <option key={option} value={option} >
                      { option + heartbeatsConstants.PERCENT_SYMBOL }
                    </option>
                  );
                })}
                </select>
                <select
                    className="minimumStreamsSelect"
                    value={setting ? setting.settings.minimum_streams : null}
                    onChange={(e) => onChangeSetting(e, setting, "minimum_streams", "settings")}
                  >
                  {this.state.minimumStreamsOptions.map(option => {
                    return (
                      <option key={option} value={option} >
                        { option + '+' }
                      </option>
                    );
                  })}
                  </select>
              </div>
            :
            <input onChange={(e) => onChangeSetting(e, setting, value, "settings")} type="number" defaultValue={setting && setting.settings[value]} min={1} name={value} className="form-control" />
          }
          { title !== 'Track Activity' && <span className="notificationReportInfoIcon" onMouseLeave={this.hideTooltip}> <i className="fas fa-info-circle" onMouseOver={this.showTooltip} /> </span> }
          {this.state.displayTooltip &&
          <div className={`tooltip-bubble tooltip-${value && tooltipSetting[value].placement}`}>
            <div className='tooltip-message'>{value && tooltipSetting[value].text}</div>
          </div>
          }
        </div>
        <div className="notification-report-set">
          <select onChange={(e) => onChangeSetting(e, setting, null, "frequency")} name={value} >
            {frequencyValues.map(value => {
              let frequency = Object.keys(frequencies)[parseInt(value)]
              return (
                <option selected={value === (setting && setting.frequency)} key={value} value={value} >
                  { this.capitalize(frequency) }
                </option>
              );
            })}
            <option selected={frequencyValues.length === (setting && setting.frequency)} key={frequencyValues.length} value={frequencyValues.length}>
              Off - no email set
            </option>
          </select>
        </div>

        { value === 'avg_streams' && (
          <div className="notification-report-table">
            <CellHeaderTable
              NoDataComponent={() => null}
              showPagination={false}
              resizable={false}
              pageSize={products.length}
              data={products}
              columns={productsColumns}
              className="report-table"
            />
          <EntityAutocomplete entities={products} value={inputValue} onChange={onChangeEntity} show={showDropdown} currentSetting={setting} reportName={value} onClickItem={onClickItem} entityName="product" entity="products" label="Artists" />
          </div>
        )}
      </div>
    )
  }
}
